import {
  TiptapEditor,
  TiptapEditorUpdatePayload,
} from 'client/components/core/tiptap-editor'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'
import CommonCheckbox from 'src/shared/components/checkbox'
import { CheckboxEntityInterface } from 'src/shared/entities/checkbox/checkbox-entity.schema'
import { CommonCheckboxSubEntityInterface } from 'src/shared/schemas/checkbox/common-checkbox-sub-entity.schema'

export interface CommonEditorCheckboxEntityOrSubEntityProps {
  entityOrSubEntity: CheckboxEntityInterface | CommonCheckboxSubEntityInterface
  checked: boolean
  onChange: () => void
  isEditing: boolean
  updateText: (payload: TiptapEditorUpdatePayload) => void
}

export const CommonEditorCheckboxEntityOrSubEntity = ({
  entityOrSubEntity,
  checked,
  onChange,
  isEditing,
  updateText,
}: CommonEditorCheckboxEntityOrSubEntityProps) => {
  const { isMobile } = useDeviceModeContext()
  const {
    text: { paragraphTextColor: globalTextColor },
    links: { linkTextColor: globalLinkColor },
  } = useThemeColor()

  const {
    calculatedFontSize,
    calculatedLineHeight,
    calculatedTextAlign,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography({
    fontSize: entityOrSubEntity.fontSize,
    mobileFontSize: entityOrSubEntity.mobileFontSize,
    lineHeight: entityOrSubEntity.lineHeight,
    mobileLineHeight: entityOrSubEntity.mobileLineHeight,
    textAlign: entityOrSubEntity.textAlign || 'left',
    mobileTextAlign: entityOrSubEntity.mobileTextAlign || 'left',
    fontFamily: entityOrSubEntity.fontFamily,
    mobileFontFamily: entityOrSubEntity.mobileFontFamily,
    fontWeight: entityOrSubEntity.fontWeight,
    mobileFontWeight: entityOrSubEntity.mobileFontWeight,
    fontStyle: entityOrSubEntity.fontStyle,
    mobileFontStyle: entityOrSubEntity.mobileFontStyle,
  })

  return (
    <CommonCheckbox
      uiProps={entityOrSubEntity}
      checked={checked}
      onChangeHandler={onChange}
    >
      <TiptapEditor
        wrapperStyles={{ flexBasis: 'inherit' }} // NOTE: https://app.shortcut.com/systeme/story/71113/checkbox-not-displaying-correctly-on-live-page-it-is-displayed-far-from-the-checkbox-text
        textAlign={calculatedTextAlign.desktop}
        editorTextAlign={
          isMobile ? calculatedTextAlign.mobile : calculatedTextAlign.desktop
        }
        isEditing={isEditing}
        content={
          entityOrSubEntity.content || entityOrSubEntity.rawContentState || ''
        }
        update={updateText}
        padding={entityOrSubEntity.padding}
        textColor={entityOrSubEntity.color || globalTextColor}
        linkColor={globalLinkColor}
        fontSize={calculatedFontSize.desktop}
        fontFamily={calculatedFontFamily.desktop}
        mobileFontFamily={calculatedFontFamily.mobile}
        fontWeight={calculatedFontWeight.desktop}
        lineHeight={calculatedLineHeight.desktop}
        mobilePadding={entityOrSubEntity.mobilePadding}
        mobileFontSize={calculatedFontSize.mobile}
        mobileLineHeight={calculatedLineHeight.mobile}
        mobileFontStyle={calculatedFontStyle.mobile}
        mobileFontWeight={calculatedFontWeight.mobile}
      />
    </CommonCheckbox>
  )
}
